import { ImageSegmenter, FilesetResolver } from "@mediapipe/tasks-vision";
import * as StackBlur from "stackblur-canvas";
export const useVideoBackground = (videoEl, canvasEl, backgroundBlurAmount) => {
    //const blurSupport = ref<boolean>(false);
    let imageSegmenter;
    let canvasCtx;
    let gpuSupport = true;
    let valid = !gpuSupport;
    const createImageSegmenter = async () => {
        if (!imageSegmenter) {
            const video = videoEl.value;
            canvasCtx = canvasEl.value.getContext("2d", { willReadFrequently: true });
            // blurSupport.value = canvasCtx.filter != undefined;
            initializeTempCanvas(video.videoWidth, video.videoHeight);
            initializeSegmenter(true);
            predictWebcam();
        }
    };
    const initializeSegmenter = (gpu) => {
        console.log(`initializeSegmenter GPU ? ${gpu}`);
        gpuSupport = gpu;
        FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm").then(async (vision) => {
            imageSegmenter = await ImageSegmenter.createFromOptions(vision, {
                baseOptions: {
                    modelAssetPath: !gpuSupport
                        ? "https://static.recollective.com/storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite"
                        : "https://static.recollective.com/storage.googleapis.com/mediapipe-models/image_segmenter/selfie_multiclass_256x256/float32/latest/selfie_multiclass_256x256.tflite",
                    delegate: gpuSupport ? "GPU" : "CPU"
                },
                runningMode: "VIDEO",
                outputCategoryMask: true,
                outputConfidenceMasks: false
            });
            console.log("imageSegmenter= ", imageSegmenter);
        });
    };
    let lastWebcamTime = -1;
    const predictWebcam = async () => {
        const video = videoEl.value;
        if (!video)
            return;
        if (video.currentTime === lastWebcamTime) {
            window.requestAnimationFrame(predictWebcam);
            return;
        }
        lastWebcamTime = video.currentTime;
        canvasEl.value.height = video.videoHeight;
        canvasEl.value.width = video.videoWidth;
        canvasCtx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        // Start segmenting the stream.
        if (imageSegmenter && backgroundBlurAmount.value > 0) {
            try {
                imageSegmenter.segmentForVideo(video, performance.now(), callbackForVideo);
            }
            catch (_e) {
                window.requestAnimationFrame(predictWebcam);
            }
        }
        else {
            window.requestAnimationFrame(predictWebcam);
        }
    };
    const tempCanvas = document.createElement("canvas");
    let tempCtx;
    // Initialize tempCanvas outside the function, so it can be reused
    const initializeTempCanvas = async (width, height) => {
        tempCanvas.width = width;
        tempCanvas.height = height;
        tempCtx = tempCanvas.getContext("2d", { willReadFrequently: true });
    };
    const callbackForVideo = async (result) => {
        // Blur the entire frame on the temporary canvas
        const video = videoEl.value;
        const canvas = canvasEl.value;
        const mask = result.categoryMask.getAsFloat32Array();
        if (canvas.width > 0) {
            // Get the current video frame data
            const frameData = canvasCtx.getImageData(0, 0, canvas.width, canvas.height);
            // Create a new temporary canvas to draw the current frame
            // Initialize temporary canvas dimensions if not done already
            if (!tempCtx) {
                await initializeTempCanvas(video.videoWidth, video.videoHeight);
            }
            tempCtx.putImageData(frameData, 0, 0);
            // Blur the entire frame on the temporary canvas
            if (tempCtx.filter != undefined) {
                tempCtx.filter = "blur(" + backgroundBlurAmount.value + "px)"; // Adjust the blur radius as needed
            }
            tempCtx.drawImage(tempCanvas, 0, 0);
            if (tempCtx.filter == undefined) {
                StackBlur.canvasRGBA(tempCanvas, 0, 0, tempCanvas.width, tempCanvas.height, backgroundBlurAmount.value * 2.2);
            }
            tempCtx = tempCanvas.getContext("2d", { willReadFrequently: true });
            const blurredData = tempCtx.getImageData(0, 0, canvas.width, canvas.height);
            const imageData = frameData.data;
            const blurred = blurredData.data;
            // Extract the person's pixels using the mask
            for (let i = 0, j = 0; i < mask.length; ++i, j += 4) {
                if (mask[i] == (gpuSupport ? 0 : 1)) {
                    // Background: use blurred version
                    imageData[j] = blurred[j];
                    imageData[j + 1] = blurred[j + 1];
                    imageData[j + 2] = blurred[j + 2];
                    // Transparency is not altered.
                }
                else {
                    valid = true;
                }
                // Else, it remains the original video data (foreground).
            }
            if (!valid) {
                initializeSegmenter(false);
            }
            // Put the composed result back onto the canvas
            canvasCtx.putImageData(frameData, 0, 0);
        }
        // Put the composed result back onto the canvas
        window.requestAnimationFrame(predictWebcam);
    };
    return { backgroundBlurAmount, createImageSegmenter };
};
